import React from 'react';
import colors from '~/data/colors';

interface CommunityTicketsProps {
  position: { x: string; y: string };
  priceHuf?: string;
  priceEur?: string;
  link: string;
  priceRsd?: string;
  pricepos: string;
  text: string;
  serial?: string;
  yPos?: number;
  onClick?: () => void;
}

const CommunityTickets: React.FC<CommunityTicketsProps> = ({
  position,
  priceHuf,
  priceEur,
  link,
  priceRsd,
  pricepos,
  text,
  serial,
  yPos,
  onClick,
}) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width={265} height={400} fill="none">
        <style>
          {` 
                .white {
                font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                font-weight: 700;
                fill:${colors.beige};
                text-transform: uppercase;

                }

                .red {
                font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                font-weight: 700;
                fill:${colors.ticketRed};
                text-transform: uppercase;

                }
                #hoveresCom{
                    transition: 0.2s;
                }
                #hoveresCom:hover
                {
                    transition: all 0.2s ;
                    transform: rotateZ(-2deg) translateY(13px);
                }`}
        </style>
        <g filter="url(#x)" id="hoveresCom">
          <path
            className="bottom-ticket"
            fill={colors.ticketRed}
            d="M245.84 266.918c-5.748 0-10.379-4.656-10.539-10.436h-12.055c-.16 5.78-4.791 10.356-10.539 10.356h-1.118c-5.749 0-10.379-4.656-10.539-10.437h-12.056c-.16 5.781-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436h-12.055c-.16 5.78-4.791 10.356-10.539 10.356h-1.118c-5.749 0-10.379-4.656-10.539-10.436h-12.056c-.16 5.78-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436H86.24c-.16 5.78-4.79 10.356-10.54 10.356h-1.117c-5.749 0-10.38-4.657-10.54-10.437H51.989c-.16 5.78-4.79 10.356-10.539 10.356h-1.118c-5.748 0-10.379-4.656-10.539-10.436H17.736c-.16 5.78-4.79 10.356-10.538 10.356H6.24L6 347.358l239.601.642.399-81.082h-.16Z"
          />

          <path
            className="bottom-ticket"
            stroke={colors.beige}
            strokeMiterlimit={10}
            strokeWidth={3.966}
            d="m229 255.57-.24 81.43L23 336.43l.16-81.43"
          />
          <path
            className="bottom-ticket"
            fill={colors.beige}
            d="m215.45 285.772-178.351-.482-.1 36.601 178.353.482.098-36.601Z"
          />
          <text
            xmlSpace="preserve"
            fill={colors.ticketRed}
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
            fontSize={17}
            fontWeight="bold"
            letterSpacing=".01em"
            style={{
              whiteSpace: 'pre',
            }}
            className="red bottom-ticket ticket-button"
          >
            <tspan x={position.x} y={position.y}>
              {text}
            </tspan>
          </text>
        </g>

        <g filter="url(#z)">
          <path
            fill={colors.ticketRed}
            d="M7.398 227.49h.558c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51H64.5c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51h1.115c5.813 0 10.512 5.144 10.512 11.51h11.946c0-6.366 4.699-11.51 10.513-11.51H246V6H7l.398 221.49Z"
          />
          <path
            stroke={colors.beige}
            strokeMiterlimit={10}
            strokeWidth={3.966}
            d="M24 239V17h205v222M23 99h206"
          />
          <text
            className="white"
            xmlSpace="preserve"
            fill="#fff"
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
            fontSize={24}
            fontWeight={800}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre',
            }}
          >
            <tspan x={pricepos} y={yPos || 146.227}>
              {priceHuf && `${priceHuf} HUF`}
            </tspan>
            <tspan x={pricepos} y={yPos || 175.227}>
              {priceRsd && `${priceRsd} RSD`}
            </tspan>
            <tspan x={pricepos} y={yPos || 204.227}>
              {priceEur && `${priceEur} EUR`}
            </tspan>
          </text>
        </g>

        <text
          xmlSpace="preserve"
          fill="#fff"
          fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
          fontSize={24}
          fontWeight="bold"
          letterSpacing=".13em"
          className="white"
          style={{
            whiteSpace: 'pre',
          }}
        >
          <tspan x={36.497} y={53.227}>
            COMMUNITY
          </tspan>
          <tspan x={39.085} y={82.227}>
            SUPPORT
            {serial ? ` #${serial}` : ''}
          </tspan>
        </text>
        <defs>
          <filter
            id="x"
            width={248}
            height={350}
            x={2}
            y={6}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={2} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_176_156"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_176_156"
              result="shape"
            />
          </filter>
          <filter
            id="y"
            width={260}
            height={112}
            x={0}
            y={250}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx={4} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_176_156"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_176_156"
              result="shape"
            />
          </filter>
          <filter
            id="z"
            width={259}
            height={253}
            x={1}
            y={0}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx={4} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_176_156"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_176_156"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </a>
  );
};

export default CommunityTickets;
